export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="w-full max-w-[960px] mx-auto">
        <div className="flex flex-col md:flex-row items-center gap-8 p-8 md:p-12 rounded-2xl bg-gradient-to-br from-primary-500/10 via-accent-500/10 to-secondary-500/10 border border-background-200/70">
          <div className="flex-1 text-center md:text-left">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              布丁漫画 · 下拉式阅读
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed max-w-md">
              布丁漫画专为韩漫读者打造下拉式阅读体验，无需翻页即可流畅浏览完整章节。
              适配手机与桌面端浏览器，随时随地畅享韩系画风与精彩剧情。
              每日更新热门韩漫资源，免下载、免注册、免费阅读全集。
            </p>
            <div className="mt-5 flex flex-wrap items-center justify-center md:justify-start gap-3">
              <a
                href="#cards"
                className="inline-flex items-center gap-2 px-6 py-2.5 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-full transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-book-open-line"></i>进入书库
              </a>
              <span className="flex items-center gap-1.5 text-sm text-foreground-500">
                <i className="ri-smartphone-line text-accent-500"></i>移动端已适配
              </span>
              <span className="flex items-center gap-1.5 text-sm text-foreground-500">
                <i className="ri-computer-line text-secondary-500"></i>桌面端已适配
              </span>
            </div>
          </div>

          <div className="flex-shrink-0">
            <div className="w-48 h-48 md:w-56 md:h-56 rounded-2xl overflow-hidden bg-gradient-to-br from-primary-100 to-accent-100 flex items-center justify-center">
              <div className="text-center">
                <div className="w-16 h-16 mx-auto mb-3 rounded-2xl bg-background-50 flex items-center justify-center">
                  <i className="ri-book-2-line text-3xl text-primary-500"></i>
                </div>
                <div className="font-heading text-lg font-bold text-foreground-950">布丁漫画</div>
                <div className="text-xs text-foreground-500 mt-1">下拉式韩漫阅读</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}